import { useState } from 'react';
import { Box, Button, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { useTranslation } from 'react-i18next';
import { setFilterUsers } from '../../../redux/slices/sellerProfileSlice';
import { useDispatch } from 'react-redux';

function UserSearchBar({ ...props }) {
  const [isBtnSown, setIsBtnShown] = useState<boolean>(false);
  const [searchName, setSearchName] = useState<string>('');

  const { t } = useTranslation();

  const dispatch = useDispatch();

  const onInputChange = (e) => {
    setSearchName(e.target.value);

    if (e.target.value) {
      setIsBtnShown(true);
    } else {
      setIsBtnShown(false);
      clearSearch();
    }
  };
  const setFilter = () => {
    props.resetSelectedFilter && props.resetSelectedFilter();
    dispatch(setFilterUsers(searchName));
  };
  const handleEnterPressSearch = (e) => {
    if (e.key === 'Enter') {
      setFilter();
    }
  };
  const handleEnterPressClear = (e) => {
    if (e.key === 'Enter') {
      e.stopPropagation();
      clearSearch();
    }
  };
  const clearSearch = () => {
    setSearchName('');
    setIsBtnShown(false);
    dispatch(setFilterUsers(''));
  };
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          marginBlock: '32px',
          height: { md: '66px' }
        }}
        className="addNewUserBtn"
      >
        <TextField
          sx={{
            width: { xs: '100%', md: '311px' },
            marginTop: 'auto',
            height: '48px'
          }}
          label={t('sellerProfile.dashboard.searchUser')}
          variant="standard"
          value={searchName}
          onChange={(e) => onInputChange(e)}
          onKeyDown={(e) => handleEnterPressSearch(e)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {isBtnSown && (
                  <ClearIcon
                    sx={{ marginBottom: '15px', cursor: 'pointer' }}
                    onClick={() => clearSearch()}
                    onKeyDown={(e) => {
                      handleEnterPressClear(e);
                    }}
                    tabIndex={0}
                    role="button"
                  />
                )}
              </InputAdornment>
            )
          }}
          InputLabelProps={{
            style: { color: 'black' }
          }}
        />
        {isBtnSown && (
          <Button
            variant="primary"
            size="md"
            tabIndex={0}
            sx={{
              mt: '20px',
              ml: '20px',

              '@media(max-width: 900px)': {
                width: '100%',
                ml: '0px'
              },
              '@media(max-width: 600px)': {
                mt: '10px'
              }
            }}
            onClick={() => setFilter()}
          >
            <SearchIcon sx={{ width: '24px', height: '24px' }} />
          </Button>
        )}
      </Box>
    </Box>
  );
}

export default UserSearchBar;
